module.exports = __webpack_public_path__ + "lui-icons.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=lui-icons.ttf!./src/resources/lui-icons.ttf
// module id = 112
// module chunks = 0